module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"interviewsMonthly":"Interviews per month","tariffTerms":"Rates","creditCard":"Pay with a credit card","onAccount":"Pay with a bank account","candidateNotification":"Candidate notification","autoInformer":"Notifications by automated calls","offlineInterviewRecord":"Record in-person interviews","recommended":"Recommended rates"}}')
  delete Component.options._Ctor
}
